import React, { useContext, useEffect, useRef, useState } from 'react';
import { getDefaultMiniColorScheme } from 'mini-color-utils/lib/colorUtils';
import { ReactAppCtx } from 'mini-app-context';
import { ReactAppSourceContext } from 'data/lib/utils/ReactAppSourceContext';
import { RsvpActions } from './RsvpActions';
import { RsvpDayView } from './RsvpDayView';
import { RsvpEventDetails } from './RsvpEventDetails';
import { RsvpFormProps } from '../schema/RsvpForm.types';
import { trySetFocusOnElement } from 'dom-utils/lib/utils/focusUtils';

const styles = require('./RsvpForm.scss');

/**
 * Component which allows user to respond to a calendar event invite.
 */
const RsvpForm = (props: RsvpFormProps) => {
    const {
        item,
        getConflictsText,
        getCalendarEvents,
        onAction,
        stringProps,
        isMessageToOrganizerAllowed,
        defaultValueUpdateOrganizerSetting,
        maxCharsAllowed,
        colorScheme = getDefaultMiniColorScheme(),
    } = props;
    const { IsAllDayEvent } = item;
    const canShowDayView = !IsAllDayEvent;
    const [isDayViewExpanded, setIsDayViewExpanded] = useState<boolean>(true);

    const forwardRef = useRef<HTMLElement>(null);

    useEffect(() => {
        setTimeout(() => trySetFocusOnElement(forwardRef), 0);
    }, []);

    const ctx = useContext(ReactAppCtx);
    const actionSource = useContext(ReactAppSourceContext);
    const signalExpandCollapse = (subSource: string) => {
        ctx?.signal(
            'RsvpDayViewExpandCollapse',
            {
                isUIAction: true,
                isExpanded: !isDayViewExpanded,
                subSource,
            },
            { actionSource }
        );
    };
    const onEventDetailsClick = () => {
        signalExpandCollapse('RsvpEventDetails' /* subSource */);
        setIsDayViewExpanded(!isDayViewExpanded);
    };

    const onAddMessageStart = () => {
        signalExpandCollapse('RsvpTextArea' /* subSource */);
        setIsDayViewExpanded(false);
    };

    return (
        <>
            <RsvpEventDetails
                item={item}
                colorScheme={colorScheme}
                getConflictsText={getConflictsText}
                canShowDayView={canShowDayView}
                isDayViewExpanded={isDayViewExpanded}
                onClick={canShowDayView ? onEventDetailsClick : null}
                forwardRef={forwardRef}
            />
            {canShowDayView && isDayViewExpanded && (
                <RsvpDayView
                    item={item}
                    colorScheme={colorScheme}
                    getCalendarEvents={getCalendarEvents}
                />
            )}
            <hr className={styles.separatorRsvp} aria-hidden />
            <RsvpActions
                item={item}
                onAddMessageFocus={canShowDayView && isDayViewExpanded ? onAddMessageStart : null}
                onRsvpAction={onAction}
                stringProps={stringProps}
                isMessageToOrganizerAllowed={isMessageToOrganizerAllowed}
                defaultValueUpdateOrganizerSetting={defaultValueUpdateOrganizerSetting}
                maxCharsAllowed={maxCharsAllowed}
                colorScheme={colorScheme}
            />
        </>
    );
};

export default RsvpForm;
